import { DELIVERY_STATUS } from 'services/music-product-digital/types/enums';

export const DELIVERY_STATUS_NOTIFICATION_TYPE_ID = 403;

export const DELIVERY_ERROR_STATUS_IDS = [
  String(DELIVERY_STATUS.error),
  String(DELIVERY_STATUS.errorProcessingACKFile),
  String(DELIVERY_STATUS.ACKFileError),
  String(DELIVERY_STATUS.errorAssigningAssetIds),
  String(DELIVERY_STATUS.withdrawError),
];

export const parseDeliveryStatusId = (id: string): DELIVERY_STATUS => {
  const numeric = Number(id);

  if (!Number.isNaN(numeric) && DELIVERY_STATUS[numeric] !== undefined) {
    return numeric as DELIVERY_STATUS;
  }

  const fromKey = DELIVERY_STATUS[id as keyof typeof DELIVERY_STATUS];

  if (typeof fromKey === 'number') {
    return fromKey;
  }

  return DELIVERY_STATUS.unknown;
};

export const toDeliveryStatusId = (status: DELIVERY_STATUS): string =>
  String(status);

export const normalizeDeliveryStatusIds = (
  deliveryStatusIds?: Array<string | number> | null,
): string[] => {
  if (!deliveryStatusIds?.length) {
    return [];
  }

  return Array.from(
    new Set(
      deliveryStatusIds
        .map(id => {
          if (typeof id === 'number') {
            if (id === DELIVERY_STATUS.unknown) {
              return null;
            }

            return toDeliveryStatusId(id as DELIVERY_STATUS);
          }

          const parsed = parseDeliveryStatusId(id);

          if (parsed === DELIVERY_STATUS.unknown) {
            return null;
          }

          return toDeliveryStatusId(parsed);
        })
        .filter((id): id is string => id !== null),
    ),
  );
};
